import { Void } from "@pdfking/tfunc"
import { defineComponent } from "vue"

let scrollY = 0

const set = (behavior = "", position = "", top = "") => {
  document.documentElement.style.scrollBehavior = behavior
  document.body.style.position = position
  document.body.style.top = top
}

export default defineComponent({
  mounted() {
    scrollY = window.scrollY // save current scroll
    set("none", "fixed", `-${scrollY}px`)
  },
  render: Void,
  unmounted() {
    set("auto")
    window.scrollTo(0, scrollY)
    // restore your original behavior after a tick
    setTimeout(() => set())
  },
})
